<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="!visibilitySpinnerGuardando" [disabled]="savingNotAllowed" type="button" class="btn btn-outline-success" (click)="onClickSave()" title="Guardar">
            <i class="fa fa-save"></i> Guardar</button>

        <button *ngIf="visibilitySpinnerGuardando" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
        
        <button class="btn btn-outline-success" type="button" [disabled]="addingNotAllowed" (click)="onClickAdd()" title="Añadir {{ titleRecintoAlmacen }}">
            <i class="fa fa-file-o"></i> Añadir {{ titleRecintoAlmacen }}</button>

        <div *ngIf="solicitudCam && !esPeriodoVigente && solicitudCam?.PeriodoPresentacionVigente === false" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo no vigente</label>
        </div>
        <div *ngIf="solicitudCam && solicitudCam?.PeriodoPresentacionVigente === false" class="ms-1 nota-info warning">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Solicitud fuera de plazo de Presentación</label>
        </div>
    </form>
</nav>

<div class="container-fluid container-list">
    
    <app-solicitud-recinto-cam-header *ngIf="solicitudCam" [formGroup]="formGroup" [solicitudCam]="solicitudCam"></app-solicitud-recinto-cam-header>

    <!-- Ventana de diálogo para selección de cultivos (recintos Parcelas o Invernaderos) -->
    <ng-container *ngIf="esSolicitudDeRecintosPI">
        <app-solicitud-recinto-cam-wrapper-cultivos 
                [recintoListMode]="recintoListMode" [readonly]="readonly" [solicitudCam]="solicitudCam" 
                [onSave$]="onSave$" [onAdd$]="onAdd$" [formGroup]="formGroup"
                (saved)="onSaved($event)" (numberOfChanges)="onNumberOfChanges($event)"
        ></app-solicitud-recinto-cam-wrapper-cultivos>
    </ng-container>

    <!-- Ventana de diálogo para selección de Almacenes - códigos de confección -->
    <ng-container *ngIf="esSolicitudDeAlmacen">
        <app-solicitud-recinto-cam-wrapper-almacenes 
                [recintoListMode]="recintoListMode" [readonly]="readonly" [solicitudCam]="solicitudCam" 
                [onSave$]="onSave$" [onAdd$]="onAdd$" [formGroup]="formGroup"
                (saved)="onSaved($event)" (numberOfChanges)="onNumberOfChanges($event)"
        ></app-solicitud-recinto-cam-wrapper-almacenes>
    </ng-container>

    <!-- Ventana de diálogo para selección de empresas de deshidratación -->
    <ng-container *ngIf="esSolicitudDeEmpresaDeshidratacion">
        <app-solicitud-recinto-cam-wrapper-empresas-deshidratadoras 
                [recintoListMode]="recintoListMode" [readonly]="readonly" [solicitudCam]="solicitudCam" 
                [onSave$]="onSave$" [onAdd$]="onAdd$" [formGroup]="formGroup"
                (saved)="onSaved($event)" (numberOfChanges)="onNumberOfChanges($event)"
        ></app-solicitud-recinto-cam-wrapper-empresas-deshidratadoras>
    </ng-container>
</div>